import { transferManager } from "../../core/service/services";
import { useObservable } from "../../utils/observable";

export const useCustomerInstruction = () => {
  const paymentNetworks = useObservable(transferManager.paymentNetworks);
  const paymentNetworksByIban = useObservable(transferManager.paymentNetworksByIban);
  const paymentNetworksOnConfig = useObservable(transferManager.paymentNetworksOnConfig);

  const getPaymentNetworks = async () => transferManager.getPaymentNetworks();

  const getPaymentNetworkProduct = async (productId: string) => transferManager.getPaymentNetworkProduct(productId);

  const getPaymentNetworksByIban = async (iban: string) => transferManager.getPaymentNetworksByIban(iban);

  const getPaymentNetworksOnConfig = async () => transferManager.getPaymentNetworksOnConfig();

  return {
    paymentNetworks,
    paymentNetworksByIban,
    paymentNetworksOnConfig,
    getPaymentNetworks,
    getPaymentNetworkProduct,
    getPaymentNetworksByIban,
    getPaymentNetworksOnConfig,
  };
};
